<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "CmsManage"
    }
</script>

<style scoped>

</style>
